import { FilterBadgeModel, FilterOption } from "../../filter/filter.model";
import { QueovalBase } from "../../models";
import { QuickSearch as QuickSearchModel } from '../../autosearch';


export class PipeColumn{
  public titre: string;
  public columnSelector: Array<FilterBadgeModel>;
  public isEditMode: boolean;
  public cards: Array<any>;
  public pagination: Pagination;
  public infoSupp: any;
  public dropDisable: boolean;
  constructor(pipeCol?: PipeColumn) {
    if (pipeCol) {
      this.titre = pipeCol.titre;
      this.columnSelector = pipeCol.columnSelector;
      this.pagination = pipeCol.pagination;
      this.dropDisable = pipeCol.dropDisable;
    }
  }
}

export class Pagination {
  public nbElement: number;
  public nbPage: number;
  public currentPage: number;
  public step: number;
  public stepOffset: number;
  public paginationLoading: boolean;
  public getPagination: boolean;

  public constructor() {
    this.nbElement = 0;
    this.nbPage = 0;
    this.currentPage = 0;
    this.step = 10;
    this.stepOffset = 0;
    this.paginationLoading = false;
    this.getPagination = false;
  }
}

export class PipeGeneralPostModel extends QueovalBase {
  public column: PipeColumn;

  public modelColumnFilter: string;
  public defaultQuickSearchOption: string;

  public newColumnName: string;
  public cardIdent: string;

  public gridName: string; 

  public filterBadges: Array<FilterBadgeModel>;
  public columnDefinition: PipeColumnDefinition;

  public constructor() {
    super();
    this.column = new PipeColumn();
    this.filterBadges = new Array<FilterBadgeModel>();

  }
}

export class PipeColumnDefinition {
  public codeBo: string;
  public codeProperty: string;
  public tableName: string;
  public tablePrefix: string;

  public columnOrderBy: string;

  public columnFilterCode: string;
  public columnFilterGroupe: string;

  //permet d'ajouter des colonnes en plus des colonnes des valeurs auto
  public extraColumn: Array<FilterBadgeModel>;
  //code pour override la recuperation des colonnes via une valeur auto
  public customColumnCode: string;

}


//#region Front only
export class TreeveiwParam {
  filterCol: string;
  displayMode: PipeDisplayMode;
  filter: string;
  model: string;
  quickSearch: string;
  custumColumn: string
}

export class ConfigParam {
  //Spécifie le préfixe des routes du contrôleur visé
  public routePrefix: string;
  //Configuration de la quickSearch
  public quickSearch: QuickSearchConfig;
  //Configuration des filtres
  public filter: FilterConfig;
  //Variable qui gère l'affichage du pipe
  public pipe: PipeConfig;
  //Definition des colonnes du pipe
  public columnDefinition: PipeColumnDefinition;
  //Etat du pipe pour switch entre le pipe et la grid
  public displayMode: PipeDisplayMode;
  //Nom de la grid 
  public gridModel: string;

  public constructor() {
    this.quickSearch = new QuickSearchConfig();
    this.filter = new FilterConfig();
    this.pipe = new PipeConfig();
    this.columnDefinition = new PipeColumnDefinition;
  }
}

export class QuickSearchConfig {
  public show: boolean;
  public defaultOptionCode: string;


  private _data: Array<QuickSearchModel>;
  public get data() {
    return this._data;
  }
  public set data(value: Array<QuickSearchModel>) {
    if (value) this.show = true;
    this._data = value;
  }


  public constructor() {
    this.show = false;
    this.data = new Array<QuickSearchModel>();
  }
}

export class FilterConfig {
  public show: boolean;
  public toggleFilter: boolean;
  public filterOption: FilterOption;
  public modelGroup?: string;
  public modelCode: string;

  public constructor() {
    this.show = true;
    this.toggleFilter = false;
    this.filterOption = new FilterOption;
  }
}

export class PipeConfig {
  public pipeMockup: boolean;
  public cardMockup: boolean;
  public displayMode: PipeDisplayMode;

  public constructor() {
    this.pipeMockup = true;
    this.cardMockup = true;
    this.displayMode = PipeDisplayMode.Pipe
  }
}

export enum PipeDisplayMode {
  Pipe,
  Grid,
}
//#endregion
